import type { FunctionComponent } from 'react'
import React, { useContext, useState } from 'react'

import { RadioGroupPage } from '../../../../shared/pages/RadioGroupPage'
import { ToolContext } from '../../../../shared/state/appContext'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { AgeFlow, ReportedToOmbudsmanFlow } from '../../pageFlowData'
import { reportedToOmbudsmanData } from './data'

export const ReportedToOmbudsman: FunctionComponent = () => {
  const [isInputValid, setInputValid] = useState(true)
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    victim: { reportedToOmbudsman },
  } = state
  const [radioSelected, setRadioSelected] = useState(reportedToOmbudsman)

  const handleChange = (id: string) => {
    setRadioSelected(id)
  }

  const handleTracking = () => {
    const trackingAnswer = `question | ${ReportedToOmbudsmanFlow.VIEW_NAME} | ${radioSelected}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = () => {
    dispatch({ type: 'UPDATE_REPORTED_TO_OMBUDSMAN', data: radioSelected })
    dispatch({ type: 'UPDATE_STEP', data: AgeFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: AgeFlow.PROGRESS_VALUE })
  }

  const handleSubmit = () => {
    if (radioSelected) {
      setInputValid(true)
      handleTracking()
      handleDispatch()
    }
    setInputValid(false)
  }

  const { buttons, title, imgObj } = reportedToOmbudsmanData

  return (
    <RadioGroupPage
      buttonText="Next"
      buttons={buttons}
      fullWidthContainer
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      imgObj={imgObj}
      isInputValid={isInputValid}
      stateValue={radioSelected}
      title={title}
    />
  )
}
